<template>
    <div class="enigma-toogle">
        <div class="enigma"
            :style="{
                'background':`linear-gradient(180deg, ${colors[colors.theme].to} 0%,  ${colors[colors.theme].from} 100%)`,
                'color' : colors.theme == 'dark' ? `#fff` : `#000`
            }"
             :class="`container-${enigma.status}`" @click="toogleEnigma(enigma)"
                       @touch="toogleEnigma(enigma)"
                       v-for="(enigma, index) in enigmasHeader"
                       :key="enigma.letter"
                       >
            <enigma-header 
                       :enigma="enigma"
                       :index="index"
                       :lastSuggestion="lastSuggestionsGroup[enigma.letter]"
            ></enigma-header>
            <enigma-body
                       :enigma="enigma"
                       :index="index">
            </enigma-body>
        </div>
    </div>
</template>
<script>
import EnigmaHeader from './EnigmaHeader.vue'
import EnigmaBody from './EnigmaBody.vue'
import Bus from '../../../main.js'
export default {
    components : {
        EnigmaHeader,
        EnigmaBody
    },
    props:{
        enigmasHeader : {
           type : Array
        },
        group : {
            
        },
        lastSuggestionsGroup : {
            default : {"a":{},"b":{},"c":{}}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    data(){
        return{
            colors: {}
        }
    },
    methods: {
        async toogleEnigma(enigma){
            // this.$store.commit('SET_OPENED_ENIGNA', enigma)
            // await this.$store.getters.getOpenedEnigma
            this.closedAllEnigmas()
            if(enigma.status == 'enigma-open'){
                enigma.status = 'enigma-closed'
            }else{
                enigma.status = 'enigma-open'
            }
            Bus.$emit(`close-${enigma.letter}`)
            this.$store.commit('SET_OPENED_ENIGNA', this.enigmasHeader)
            // console.log("enigmas: ", this.enigmasHeader)
        },
        closedAllEnigmas(){
            let enigmas = this.enigmasHeader
            enigmas.forEach((enigma) => {
                enigma.status = 'enigma-closed'
            })
        }
    }
}
</script>
<style lang="scss" scoped>

    .enigma-toogle{
        
        display: flex;
        flex-direction: column;
        height: 90vh;
    }

    .container-enigma-open{
        height: 75vh;
    }

    @media only screen and (min-width: 750px){
        .enigma-toogle{
            height: 100%;

            .container-enigma-open{
                height: calc(100% - 110px);
            }
        }
    }

</style>
